module.exports = __webpack_public_path__ + "static/img/RAP-RJ45_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAP-RJ45_1.png
// module id = gnkq
// module chunks = 0